import {
  Pipe,
  PipeTransform
} from '@angular/core';

@Pipe({name: 'numberDeclensionFormat'})
export class NumberDeclensionFormatPipe implements PipeTransform {
  transform(_number: number): string {
    const numerlas = {
      1: 'Pierwszy numer',
      2: 'Drugi numer',
      3: 'Trzeci numer',
      4: 'Czwarty numer',
      5: 'Piąty numer',
      6: 'Szósty numer',
      7: 'Siódmy numer',
      8: 'Ósmy numer',
      9: 'Dziewiąty numer',
      10: 'Dziesiąty numer',
      11: 'Jedenasty numer',
      12: 'Dwunasty numer',
      13: 'Trzynasty numer',
      14: 'Czternasty numer',
      15: 'Piętnasty numer',
      16: 'Szesnasty numer',
      17: 'Siedemnasty numer',
      18: 'Osiemnasty numer',
      19: 'Dziewietnasty numer',
      20: 'Dwudziesty numer'
    };

    return numerlas[_number];
  }
}
